module.exports = __webpack_public_path__ + "static/media/Archive.72895630.svg";